<template>
  <div class="imgBox">
       <el-upload
        action=""
        :auto-upload=false
        :multiple=true
        :on-change="imgPreview"
        list-type="picture-card"
        accept="image/*"
        :limit="20"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove" :class="[isAdd?'hidden':'']">
      </el-upload>
      <span style="font-size:12px">最多上传{{imgData.max}}张，支持jpg、png格式图片</span>
      <el-dialog  title="图片展示" :visible.sync="dialogVisible" center>
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </div>
</template>

<script>

export default {
  name: 'uploadImgs',
  props: {
    imgData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      imgList: [],
      YimgList: [],
      dialogImageUrl: '',
      isAdd: false,
      dialogVisible: false,
      max: 0
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM

  },
  methods: {
    // 图片上传
    handleRemove (file, fileList) {
      this.$emit('remove', fileList)
      if (fileList.length < this.imgData.max) {
        this.isAdd = false
      }
    },

    imgPreview (file, fileList) {
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.png)$/
      if (regex.test(fileName.toLowerCase())) {
        this.$emit('change', fileList)
        if (fileList.length < this.imgData.max) {
          this.isAdd = false
        } else {
          this.isAdd = true
        }
      } else {
        fileList.pop()
        this.$alert('请选择图片文件图', '系统提示')
        return false
      }
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.imgBox{
  margin: 22px 10px;
}

.hidden /deep/.el-upload--picture-card{
  display: none;
}
</style>
